import { useTranslation } from "@vixi/localization";
import { ButtonLink, cn, FormHeading, ScreenTooltip, StyledTextLink } from "@vixi/ui";
import { ComponentProps, forwardRef } from "react";

import { LangKey } from "@vixi/localization";
import { PlusIcon } from "lucide-react";

interface LegendItemProps extends ComponentProps<"div"> {
  icon?: React.ReactNode;
  itemName: LangKey;
}

const LegendItem = forwardRef<HTMLDivElement, LegendItemProps>(
  ({ color, itemName: title, children: description, icon, ...props }, ref) => {
    const { t } = useTranslation();

    return (
      <div
        className="fs-15 relative flex flex-col items-center leading-normal xl:flex-row"
        {...props}
        ref={ref}
      >
        <div className="flex items-center">
          {icon}
          <h3 className="fs-inherit leading-inherit ms-2.5 font-bold">{t(title)}</h3>
        </div>

        <p className="fs-inherit leading-inherit font-medium">{description}</p>
      </div>
    );
  },
);

const AvatarLegend = forwardRef<HTMLDivElement, ComponentProps<"div">>((props, ref) => {
  const { t } = useTranslation();

  return (
    <div
      {...props}
      className={cn(
        "bg-paper flex flex-col items-center rounded  pe-3 xl:flex-row",
        props.className,
      )}
      ref={ref}
    >
      <FormHeading heading="Avatars.LegendTitle" >
        <div className="flex items-end gap-3">
          <p className="text-foreground-secondary ">{t("Avatars.LegendDescription")}</p>
          <ScreenTooltip image="/images/screens/avatar-in-course.png">
            <StyledTextLink>{t("Action.SeeHow")}</StyledTextLink>
          </ScreenTooltip>
        </div>
      </FormHeading>
 

      <ButtonLink
        to="/avatars/create"
        size="medium"
        variant="contained"
        color="premium"
        className="ms-auto me-auto   xl:me-0 xl:mt-0 fs-16 fw-semibold"

      >
        {t("Avatars.CreateAvatars")}
      </ButtonLink>
    </div>
  );
});

export default AvatarLegend;
